import React from "react";
import { withIntelligenceDateControls } from "./../../../shared/containers/containerIntelligenceDateControls";
import IntelligenceDateForm from "./intelligenceDateForm";
import styles from "./carsIntellegence.module.scss";

const IntelligenceDateControls = ({ isIntelligenceDateControlsOpen }) => {
  return isIntelligenceDateControlsOpen ? (
    <div className={styles.intelligenceDateControls}>
      <div>
        <div className={styles.container_dateTimeWrapper}>
          <IntelligenceDateForm />
        </div>
      </div>
    </div>
  ) : null;
};

export default withIntelligenceDateControls(React.memo(IntelligenceDateControls));
